import { render, staticRenderFns } from "./AccountContext.vue?vue&type=template&id=2886ba38&scoped=true"
import script from "./AccountContext.vue?vue&type=script&lang=js"
export * from "./AccountContext.vue?vue&type=script&lang=js"
import style0 from "./AccountContext.vue?vue&type=style&index=0&id=2886ba38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2886ba38",
  null
  
)

export default component.exports